<template>
  <div class="epfm">
    <el-switch
      v-if="isEdit"
      class="switch-on"
      :class="{ active: fixed }"
      :width="30"
      v-model="fixed"
    ></el-switch>
    <div class="module-menu" v-if="isEdit" :class="{ fixed }" v-resize="menuResize">
      <div ref="function" class="function">
        <domain @funcHandle="handleFunc" :isDel="isDel" :border="border" :prior="prior" />
      </div>
      <div class="module-container" @mouseleave="undisChart" @scroll="mouseScroll">
        <ul class="module-list">
          <li class="module-item" @mouseenter="undisChart">
            <icon
              @click.native="moduleMenu = true"
              class="module-icon"
              name="icon-zengjia"
              size="30"
              color="#247ADE"
              title="添加模块"
            />
          </li>
          <li
            class="module-item"
            @mouseenter="disChart(item, 'modal_' + item.id)"
            v-for="item in modals"
            :key="item.id"
            :ref="'modal_' + item.id"
          >
            <icon
              draggable="true"
              class="module-icon"
              :name="item.icon ? item.icon : 'icon-mokuai'"
              :size="item.size ? item.size : 30"
              :color="item.color ? item.color : '#9f9898'"
              :title="item.name"
            />
          </li>
        </ul>
        <el-dialog
          :append-to-body="true"
          @closed="addModalType = null"
          :destroy-on-close="true"
          custom-class="add-module-wrapper"
          title="添加模块"
          :visible.sync="moduleMenu"
        >
          <cards ref="mycards" @selType="setModalType" />
          <div class="data-wrapper">
            <options ref="optionSetting" :type="addModalType" />
            <excelUpload @handleData="setOption" :type="addModalType">
              <micon ref="icons" />
            </excelUpload>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="moduleMenu = false">取 消</el-button>
            <el-button type="primary" @click="addModule">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div :style="preview" class="preview">
        <keep-alive>
          <component :is="hoverM" :name="actM" :move="moveStamp"></component>
        </keep-alive>
      </div>
    </div>
    <div
      ref="exhibition"
      class="exhibition"
      :style="bgStyle"
      @mousemove="dragmove"
      @mouseup="pressrelease"
      @mouseleave="outflexbox"
    >
      <flexbox
        @clear="clearFB"
        v-for="item in flexNum"
        :ref="item.id"
        :key="item.id"
        :border="border"
        :prior="prior"
        :isDel="isDel"
        :id="item.id"
        :axis="axis"
        :widh="widh"
        :cpts="modals_1"
        :coms="comps"
        :modal="actM || `modal_${item.modalId}`"
        :obj="item"
      />
    </div>
    <el-dialog
      :append-to-body="true"
      @closed="sceneData.sceneTitle = null"
      :destroy-on-close="true"
      custom-class="title-module-wrapper"
      title="场景标题"
      :visible.sync="sceneDialog"
    >
      <el-form
        :model="sceneData"
        :rules="titleRule"
        ref="titleForm"
        label-width="100px"
        style="padding: 15px 20px"
      >
        <el-form-item label="输入标题" prop="sceneTitle">
          <el-input v-model="sceneData.sceneTitle"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-right: 40px" @click="sceneDialog = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="titleValidate">确 定</el-button>
      </div>
    </el-dialog>
    <el-drawer
      title="背景设置"
      :visible.sync="setDialog"
      :destroy-on-close="true"
      custom-class="back-setting"
      ref="mydrawer"
    >
      <backSetting :set="setting" @cancel="setDialog = false" @effect="alterBgSetting" />
    </el-drawer>
  </div>
</template>

<script>
import $pubsub from "./utils/pubsub.js";
import Vue from "vue";
import {
  Switch,
  Dialog,
  Drawer,
  Button,
  Upload,
  Message,
  Icon,
  Row,
  Col,
  Card,
  Link,
  Image,
  ColorPicker,
  Form,
  FormItem,
  Select,
  Slider,
  Option,
  Input,
  CheckboxGroup,
  Checkbox,
  RadioGroup,
  Radio,
} from "element-ui";
const Components = [
  Switch,
  Dialog,
  Drawer,
  Button,
  Upload,
  Message,
  Icon,
  Row,
  Col,
  Card,
  Link,
  Image,
  ColorPicker,
  Form,
  FormItem,
  Select,
  Slider,
  Option,
  Input,
  CheckboxGroup,
  Checkbox,
  RadioGroup,
  Radio,
];
Components.forEach((comp) => {
  Vue.component(comp.name, comp);
});
import domain from "./components/domain.vue";
import cards from "./components/cards.vue";
import excelUpload from "./components/excelUpload.vue";
import icon from "./components/icon.vue";
import flexbox from "./components/flexbox.vue";
import micon from "./components/micon";
import options from "./components/options";
import backSetting from "./components/backSetting";
import * as merge from "./utils/merge";
import { whiteType } from "./utils/tools";
export default {
  name: "epfm",
  props: {
    isEdit: {
      type: Boolean,
      default: () => true,
    },
    inputScene: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    domain,
    cards,
    excelUpload,
    flexbox,
    icon,
    micon,
    options,
    backSetting,
  },
  directives: {
    resize: {
      bind(el, binding, vnode) {
        let width = "",
          height = "";
        function trend(a, b) {
          if (!a) {
            return parseInt(b) > 30 ? false : true;
          }
          return parseInt(a) - parseInt(b) > 0 ? true : false;
        }
        function isReize() {
          const style = document.defaultView.getComputedStyle(el);
          if (width !== style.width || height !== style.height) {
            binding.value(); // 关键
            vnode.context.collapse = trend(width, style.width);
          }
          width = style.width;
          height = style.height;
        }
        el.__vueSetInterval__ = setInterval(isReize, 500);
      },
      unbind(el) {
        clearInterval(el.__vueSetInterval__);
      },
    },
  },
  data() {
    return {
      sceneDialog: false,
      sceneData: {
        sceneTitle: null,
      },
      titleRule: {
        sceneTitle: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
      moveStamp: 0,
      modals: [],
      comps: {},
      chartOption: null,
      moduleMenu: false,
      modals_1: [],
      setDialog: false,
      setting: {
        actStr: "dot",
        dot: true,
        bgcolor: null,
        gbgcolor: {
          type: "linear-gradient",
          colors: ["#409EFF", "#409EFF"],
        },
        localImg: null,
        netImg: null,
      },
      bgStyle: {
        backgroundImage: `url(${require("./imgs/doted.png")})`,
        backgroundSize: "12px",
      },
      prior: false,
      axis: [],
      widh: {},
      collapse: true,
      fixed: false,
      isDel: false,
      border: true,
      preview: {
        display: "none",
        top: null,
      },
      actM: null,
      hoverM: null,
      modal: null,
      scrollTop: 0,
      flexNum: [],
      iconStyle: {
        height: "25px",
        lineHeight: "25px",
        width: "100%",
        textAlign: "center",
        padding: "2px 0",
        borderTop: "1px solid #fff",
      },
      addModalType: null,
    };
  },
  watch: {
    inputScene: {
      handler(newval, oldval) {
        if (newval !== oldval) {
          this.loadScene();
        }
      },
    },
  },
  created() {
    this.loadModules();
  },
  mounted() {
    window.onresize = () => {
      this.reloadSize();
    };
    if (!this.isEdit) {
      document.addEventListener("keydown", this.keydownSave);
      this.widh = {
        w: this.$refs.exhibition.offsetWidth,
        h: this.$refs.exhibition.offsetHeight,
      };
      // this.loadScene();
    } else {
      document.title = 'elastic-pfm';
      this.modals_1 = JSON.parse(JSON.stringify(this.modals));
    }
  },
  beforeDestroy() {
    if (!this.isEdit) {
      document.removeEventListener("keydown", this.keydownSave);
    }
    window.onresize = null;
  },
  methods: {
    loadModules() {
      const _this = this;
      const store = $pubsub();
      const initData = ["comps"];
      if (this.isEdit) {
        initData.push("modals");
      }
      initData.forEach((item) => {
        _this[item] = store.getter(item);
      });
    },
    addModule() {
      const moduleType = this.$refs.mycards.getCompType();
      if (!moduleType) {
        Message("请选择模板！");
        return;
      }
      const optionType = this.$refs.optionSetting.getOptionSetting();
      if (typeof optionType === "string") {
        Message(optionType);
        return;
      }

      const option = !whiteType.includes(moduleType) ? this.chartOption : {};
      if (!option) {
        Message("请检查操作，确认无误后再提交！");
        return;
      }
      const iconObj = this.$refs.icons.getIcon();
      if (!iconObj.icon || !iconObj.iconColor) {
        Message("请选择小图标或颜色，确认无误后再提交！");
        return;
      }
      const optionName = `${moduleType}_${Date.now()}`;
      const modal = {
        id: Date.now(),
        name: option.name,
        icon: iconObj.icon,
        color: iconObj.iconColor,
        size: null,
        component: moduleType,
        optionName: optionName,
      };
      const store = $pubsub();
      const lastOption = !whiteType.includes(moduleType)
        ? merge[moduleType](optionType, option.data)
        : optionType;

      if (whiteType.includes(moduleType)) {
        modal.name = lastOption.name;
      }

      store.addAttr("options", optionName, lastOption);
      store.addChild("modals", modal);
      this.modals = store.getter("modals");
      this.modals_1 = store.getter("modals");
      this.comps = store.getter("comps");
      this.moduleMenu = false;
      this.chartOption = null;
      Message({
        message: "添加模块成功",
        type: "success",
        duration: 3000,
      });
    },
    setOption(obj) {
      this.chartOption = obj;
      // console.log("option==>",JSON.parse(JSON.stringify(obj.data)));
    },
    handleFunc(n) {
      switch (n) {
        case 1:
          this.addFlexbox();
          break;
        case 2:
          this.isDel = !this.isDel;
          break;
        case 3:
          this.border = !this.border;
          break;
        case 4:
          this.setDialog = true;
          break;
        case 5:
          this.prior = !this.prior;
          break;
        case 6:
          this.sceneDialog = true;
          break;
        case 7:
          this.toScene();
          break;
      }
    },
    toScene() {
      this.$router.push("/scene");
    },
    cancelbg() {
      this.setDialog = false;
      this.setting = {
        dot: true,
        bgcolor: null,
        gbgcolor: null,
        localImg: null,
        netImg: null,
      };
    },
    bgStrategy(type, value) {
      switch (type) {
        case "dot":
          value
            ? (this.bgStyle = {
                backgroundImage: `url(${require("./imgs/doted.png")})`,
                backgroundSize: "12px",
              })
            : (this.bgStyle = {});
          break;
        case "bgcolor":
          this.bgStyle = {
            backgroundColor: value,
          };
          break;
        case "gbgcolor":
          this.bgStyle = {
            backgroundImage: `${value.type}(${value.colors.join()})`,
          };
          break;
        case "localImg":
          this.bgStyle = {
            backgroundImage: `url(${value})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          };
          break;
        case "netImg":
          this.bgStyle = {
            backgroundImage: `url(${value})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          };
          break;
        default:
          this.bgStyle = {};
      }
    },
    alterBgSetting(obj) {
      console.log(obj);
      this.setting = JSON.parse(JSON.stringify(obj));
      const type = this.setting.actStr;
      const value = this.setting[type];
      this.bgStrategy(type, value);
      this.setDialog = false;
    },
    flexSetting() {
      return alert("该功能暂未开放!");
    },
    dragmove(e) {
      this.axis = [e.clientX, e.clientY, false];
    },
    pressrelease() {
      this.axis = [...this.axis.slice(0, 2), true];
    },
    outflexbox() {
      this.axis = [...this.axis.slice(0, 2), true];
    },
    reloadSize() {
      this.widh = {
        w: this.$refs.exhibition.offsetWidth,
        h: this.$refs.exhibition.offsetHeight,
      };
      if (this.isEdit) {
        // 编辑状态计算高度
        this.modal = this.$refs.function.offsetHeight + 30;
      }
    },
    menuResize() {
      this.reloadSize();
    },
    addFlexbox() {
      const box = {
        id: "flex_" + Date.now(),
      };
      this.flexNum.push(box);
    },
    clearFB(id) {
      this.flexNum = this.flexNum.filter((item) => item.id !== id);
    },
    mouseScroll(e) {
      this.scrollTop = e.target.scrollTop;
    },
    disChart(row, ref) {
      this.moveStamp = Date.now();
      this.actM = ref;
      const offsetop = this.$refs[ref][0].offsetTop;
      const top = offsetop + this.modal - 100 - this.scrollTop;
      this.hoverM = this.comps[row.component] ? this.comps[row.component] : row.component;
      this.preview = {
        display: "block",
        top: top + "px",
      };
    },
    undisChart() {
      this.preview.display = "none";
      this.hoverM = null;
    },
    keydownSave(e) {
      var key = window.event.keyCode ? window.event.keyCode : window.event.which;
      if (key === 83 && e.ctrlKey) {
        this.sceneDialog = true;
        e.preventDefault();
      }
    },
    titleValidate() {
      this.$refs.titleForm.validate((valid) => {
        if (valid) {
          this.saveScene(this.sceneData.sceneTitle);
        } else {
          Message("请输入标题后再保存！");
          this.sceneData.sceneTitle = null;
          return false;
        }
      });
    },
    saveScene(title) {
      const store = $pubsub();
      const flexBoxes = [];
      for (let i = 0, len = this.flexNum.length; i < len; i++) {
        const data = this.$refs[this.flexNum[i].id][0].pickData();
        flexBoxes.push(data);
      }
      const newScene = {
        createTime: Date.now(),
        title: title,
        backSetting: JSON.parse(JSON.stringify(this.setting)),
        flexBoxes: flexBoxes,
        modals: store.getter("modals"),
        options: store.getter("options"),
      };
      this.$emit("saveHandle", newScene);
      this.sceneDialog = false;
      this.sceneData.sceneTitle = null;
    },
    loadScene() {
      if (this.inputScene && JSON.stringify(this.inputScene) !== "{}") {
        const { title, backSetting, flexBoxes, modals, options } = this.inputScene;
        this.setting = backSetting;
        const type = this.setting.actStr;
        const value = this.setting[type];
        this.bgStrategy(type, value);
        this.modals = modals;
        this.modals_1 = modals;
        this.flexNum = flexBoxes;
        const store = $pubsub();
        store.setter("modals", modals);
        store.setter("options", options);
        document.title = title;
      }
    },
    setModalType(type) {
      this.addModalType = type;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./css/common.css";
@import "./css/element.scss";
@import "./css/dialog.scss";
@import "./css/iconfont/iconfont.css";
.epfm {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  position: relative;
  box-sizing: border-box;
  display: flex;

  .switch-on {
    position: absolute;
    top: 0;
    left: -9px;
    margin: 5px 0;
    box-shadow: 0px 1px 3px 1px #00000087;
    border-radius: 10px;
    transition: left 0.5s cubic-bezier(0.73, -0.39, 0.35, 1.23);

    &.active {
      left: 12px;
    }
  }

  // 模型盒
  .module-menu {
    width: 0;
    height: calc(100% - 30px);
    margin-top: 30px;
    margin-right: 20px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: width 0.5s cubic-bezier(0.73, -0.39, 0.35, 1.23);

    &.fixed {
      width: 54px;
    }

    .function {
      width: 96%;
      border: 1px solid transparent;
      border-radius: 5px;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      box-shadow: 0 0 30px -5px rgba(0, 0, 0, 0.15);
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: hidden;
      transition: border 0.5s cubic-bezier(0.73, -0.39, 0.35, 1.23);
    }

    .module-container {
      flex: 1;
      width: 96%;
      border: 1px solid transparent;
      border-radius: 5px;
      border-top-right-radius: 0;
      border-top-left-radius: 0;
      box-shadow: 0 0 30px -5px rgba(0, 0, 0, 0.15);
      overflow: auto;
      position: relative;
      scrollbar-width: none;
      transition: border 0.5s cubic-bezier(0.73, -0.39, 0.35, 1.23);

      &::-webkit-scrollbar {
        display: none;
      }

      .module-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .module-item {
          width: 100%;
          height: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          .module-icon {
            padding: 7px 11px;
            cursor: pointer;
            transition: all 0.3s linear;

            &:hover {
              background-color: #00a4ff;
              color: #fff !important;
            }
          }
        }
      }
    }

    .fixed-icon {
      cursor: pointer;
      transition: all 0.3s linear;
      &:hover {
        color: #409eff !important;
      }
      &.active {
        color: #409eff !important;
      }
    }

    .preview {
      width: 150px;
      height: 150px;
      background-color: #fff;
      padding: 0 2px 2px 0;
      box-sizing: border-box;
      position: absolute;
      left: 55px;
      overflow: hidden;
      z-index: 10000;
      border-radius: 8px;
      box-shadow: 1px 1px 10px 1px #000000a8;
      transition: all 0.5s cubic-bezier(0.73, -0.39, 0.35, 1.23);
    }
  }

  .fixed .function,
  .fixed .module-container {
    border: 1px solid #00a4ff;
  }

  // 展示画板
  .exhibition {
    flex: 1;
    overflow: hidden;
    position: relative;
  }
}
</style>
